import { FC, useMemo } from 'react'
import cn from 'classnames'
import themes from 'styles/base/themes.styl'
import styles from 'components/atoms/Separator/Separator.styl'
import { Separator as RadixSeparator, SeparatorProps as RadixSeparatorProps } from '@radix-ui/react-separator'
import { Theme } from 'interfaces/component'

type SeparatorProps =
  & RadixSeparatorProps
  & {
    title?: string
    asListItem?: boolean
    className?: string
    theme?: Theme
    large?: boolean
    vertical?: boolean
  }

export const Separator: FC<SeparatorProps> = (props) => {
  const {
    decorative,
    large,
    vertical,
    title,
    asListItem,
    className,
    theme = 'stone',
  } = props
  const separatorChild = useMemo(() => (
    <>
      { !!title && <span>{ title }</span> }
      <RadixSeparator
        orientation={ !vertical ? 'horizontal' : 'vertical' }
        decorative={ decorative }
      />
    </> 
  ), [decorative, title, vertical])

  const themeClass = !!theme ? themes[theme] : undefined

  const classNames = cn(
    styles.separator,
    themeClass,
    className,
    themes.textOnly, {
      [styles.large]: large,
    }
  )

  return asListItem ? (
    <li className={ classNames }>{ separatorChild }</li>
  ) : (
    <div className={ classNames }>{ separatorChild }</div>
  )
}

export default Separator
